<template lang="pug">
modal-base.modal-window(
  ref='modalBase',
  :width='width',
  :height='height',
  :clickToClose='clickToClose',
  @closed='closed'
)
  .modal-window__header(v-if='title')
    title-letter.modal-window__header__title {{ title }}
    .modal-window__header__close(v-if='showCloseButton', @click='hide')
      fa-icon(icon='times')
  .modal-window__body
    slot
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalBase from '@/components/atoms/ModalBase.vue'
import TitleLetter from '@/components/atoms/TitleLetter.vue'

/**
 * モーダルウインドウ
 */
@Component({
  components: {
    ModalBase,
    TitleLetter,
  },
})
export default class ModalWindow extends Vue {
  // モーダル表示幅(px) - 必須
  @Prop()
  width!: number

  // モーダル表示高さ(px) - 必須
  @Prop()
  height!: number

  // タイトル表示文字列
  @Prop()
  title?: string

  // 背景クリック時にモーダルを閉じるか否か(ライブラリオプション)
  //   未指定時は閉じる
  @Prop({ default: true })
  clickToClose?: boolean

  // ヘッダーの閉じるボタンを表示するか否か
  //   未指定時は表示する
  @Prop({ default: true })
  showCloseButton?: boolean

  // モーダルベースのref定義
  @Ref() modalBase!: ModalBase

  // モーダルの消去
  hide() {
    this.modalBase.hide()
  }

  // モーダルの表示
  show() {
    this.modalBase.show()
  }

  // モーダル消去時のイベントを通知
  //   @closed='function'でモーダル消去時に処理の実行が可能
  private closed() {
    this.$emit('closed')
  }
}
</script>

<style lang="stylus" scoped>
.modal-window
  &__header
    padding 10px
    background-color var(--color-modal-header__background)
    color var(--color-modal-header__text)
    height 50px
    display flex
    &__title
      margin 0 15px
      flex auto
      text-align left
      display flex
      justify-content center
      align-items center
    &__close
      width 30px
      text-align center
      cursor pointer
</style>
